import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { BsFillReplyAllFill, BsDash } from "react-icons/bs";
import { FiChevronUp } from "react-icons/fi";
import { tipu, mockTestBg } from "../../assets";
import TopBanner from "../../components/designTab/TopBanner";
import CoursesIntro from "../../components/pageProps/CoursesIntro";
import Bonus from "../../components/pageProps/Bonus";

const IeltsMockTest = () => {
  // ================ Course Module start here ==================
  const [showListeningModule, setShowListeningModule] = useState(true);
  const [showSpeakingModule, setShowSpeakingModule] = useState(false);
  const [showReadingModule, setShowReadingModule] = useState(false);
  const [showReadingModuleGeneral, setShowReadingModuleGeneral] =
    useState(false);
  const [showWritingModule, setShowWritingModule] = useState(false);
  const [showWritingModuleGeneral, setShowWritingModuleGeneral] =
    useState(false);
  // ================ Course Module end here ====================
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>IELTS Mock Test - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="IELTS Mock Test" />
      <div className="max-w-screen-xl mx-auto pb-4 pt-2 px-4 flex flex-col lgl:flex-row items-start xl:gap-10 justify-between">
        <div className="w-full flex flex-col gap-4 md:gap-10">
          <CoursesIntro
            intro="Introduction"
            des="IELTS Mock Test is very important for the students who are about to attend the final exam of IELTS. IELTS Mock Test increase their confidence which helps for the IELTS Exam."
            instructorName="Masud Parvej Tipu"
            instructorTitle="Head Of Faculty, English"
            instructorImg={tipu}
            classTitle="Fixed Package"
            langClubTitle="Mock Test"
            langClubNo="3"
            debate="counselling"
            supportTitle="SUPPORT"
            support="24/7"
            bg={mockTestBg}
          />
          {/* =====================================================
                          Course overview start here
             ===================================================== */}

          <div>
            <h3 className="font-banglaFont text-xl md:text-2xl font-semibold mb-1 md:mb-4">
              Benefits of IELTS Mock Test :
            </h3>
            <div className="w-full border hover:shadow-lg transition-hover duration-300 border-primeColor rounded-md border-opacity-30 p-4 flex justify-start items-center gap-4">
              <div>
                <ul className="ulListBangla">
                  <li className="listli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Well aware of examination procedure.
                  </li>
                  <li className="listli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    It will grow your confidence.
                  </li>
                  <li className="listli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    If any mistake happens then teacher will provide necessary
                    treatment.
                  </li>
                  <li className="listli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Teacher will provide necessary tips to do best on your final
                    exam.
                  </li>
                  <li className="listli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Knowing your capacity & working area.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <h3 className="font-banglaFont text-xl md:text-2xl font-semibold mb-1 md:mb-4">
              Why IELTS Mock Test is for you?
            </h3>
            <div className="w-full border hover:shadow-lg transition-hover duration-300 border-primeColor rounded-md border-opacity-30 p-4 flex justify-start items-center gap-4">
              <div>
                <ul className="ulListBangla">
                  <li className="listli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    IELTS Mock Test is very important for the students who are
                    about to attend the final exam of IELTS. IELTS Mock Test
                    increase their confidence which helps for the IELTS Exam.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* =====================================================
                          Course overview end here
             ===================================================== */}
          {/* =====================================================
                          Course MODULE start here
             ===================================================== */}

          <h3 className="font-titleFont text-xl md:text-2xl font-semibold -mb-4">
            Course Modules
          </h3>
          <div className="w-full border hover:shadow-lg transition-hover duration-200 border-primeColor rounded-md border-opacity-30 p-4">
            {/* =================== Listening Module Start here ============== */}
            <div>
              <h3
                onClick={() => setShowListeningModule(!showListeningModule)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Listening Module :
                {showListeningModule ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showListeningModule && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Listening: Format
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Listening: Form Completion
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Listening: Labelling Map and Diagram
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Listening: Multiple Choice Questions
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Listening: Sentence Completion and Gap Fill
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Speaking Module Start here ============== */}
            <div>
              <h3
                onClick={() => setShowSpeakingModule(!showSpeakingModule)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Speaking Module :
                {showSpeakingModule ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showSpeakingModule && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Speaking: Format
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Speaking: How to Greet Your Examiner
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Speaking: How to Improve Your IELTS Speaking at Home
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Speaking: Part 1: Common Topics
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Speaking: Part 2: Common Topics
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Speaking: 5 Advanced Words to Use in Your IELTS Speaking
                        Test 1
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Speaking: 5 Advanced Words to Use in Your IELTS Speaking
                        Test 2
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Speaking: How to Introduce Yourself in English
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Speaking: What are your hobbies? - Easy Tips to Answer
                        This Question
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Speaking: What's Your Favorite... ?
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Reading Module Academic Start here ============== */}
            <div>
              <h3
                onClick={() => setShowReadingModule(!showReadingModule)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Reading Module (Academic) :
                {showReadingModule ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showReadingModule && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Reading Format
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Paragraph Headings
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Multiple Choice Questions
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Quiz: Reading: Multiple Choice Questions
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: True/False/Not Given
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Quiz: Reading: True/False/Not Given
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Matching Paragraph Information
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Sentence Completion
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Short Answer Questions
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Gap Fill
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Reading Module General Start here ============== */}
            <div>
              <h3
                onClick={() =>
                  setShowReadingModuleGeneral(!showReadingModuleGeneral)
                }
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Reading Module (General Training) :
                {showReadingModuleGeneral ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showReadingModuleGeneral && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Format
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Matching Paragraph Headings
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Multiple Choice Questions
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Matching Paragraph Information
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Matching Sentence Endings
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Gap Fill
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Diagram Label Completion
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: True/False/Not Given
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reading: Short Answer Questions
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Writing Module Academic Start here ============== */}
            <div>
              <h3
                onClick={() => setShowWritingModule(!showWritingModule)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Writing Module( Academic) :
                {showWritingModule ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showWritingModule && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Writing Format
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 1 - Structure
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 1 - Graphs
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 1 - Maps
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 1 - Describing A Diagram /Process
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 2 - Structure
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 2: Agree/Disagree Essay
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 2: Advantage/Disadvantage Essay
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 2: Cause/Solution Essay
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 2: Discussion Essay
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 2: Direct question Essay
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Writing Module General Start here ============== */}
            <div>
              <h3
                onClick={() =>
                  setShowWritingModuleGeneral(!showWritingModuleGeneral)
                }
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Writing module (General Training) :
                {showWritingModuleGeneral ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showWritingModuleGeneral && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Format
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Structure and Tips for Writing Task 1 (Letter)
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 1: Formal Letter
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 1: Semi-Formal Letter
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 1 - Describing A Diagram /Process
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Writing: Task 1: Informal Letter
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        IELTS : Conclusion
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
          </div>
          <div>
            <Bonus
              bonus="In your last Mock Test, the instructor will provide you with tips for all parts (Listening, Reading, Writing, & Speaking)."
              awards="Based on your performance, you will be awarded. Also, we will provide you with the certificate after completing the course."
            />
          </div>
          {/* =====================================================
                          Course MODULE end here
             ===================================================== */}
        </div>

        {/* =================== Right Part start here ======================= */}
      </div>
    </div>
  );
};

export default IeltsMockTest;
